import { SHORTER_TIMEOUT_BEFORE_NEW_CHAT } from '../../common/constants/private';

export const getTimeoutBeforeExpiration = (): number => {
	return SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};
